import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addOptionValue({ commit }, item) {
    return this.$axios.$post('admin/optionValues/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeOptionValue({ commit }, item) {
    return this.$axios.$delete(`admin/optionValues/${item.id}`).then((response) => {
      const { error } = response
      if (error) {
        return response
      } else if (response.data) {
        commit('remove', item)
        return response.data
      }
    })
  },
  updateOptionValue({ commit }, item) {
    return this.$axios.$put(`admin/optionValues/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchOptionValue({ commit }, id) {
    return this.$axios.$get(`admin/optionValues/${id}`).then((response) => {
      return response.data
    })
  },
  fetchOptionValues({ commit }) {
    return this.$axios.$get('admin/optionValues').then((response) => {
      commit('load', response.data)
    })
  },
}
